// extracted by mini-css-extract-plugin
export default {"titleActions":"rolesManagement_titleActions__QzxMw","container":"rolesManagement_container__N5xXt","actions":"rolesManagement_actions__ijioi"};